import OrganizationEdit from '@/screens/OrganizationEdit';

export default function OrganizationEditRoute() {
  return <OrganizationEdit />;
}
